import { useEffect } from 'react';
import { Typography } from '@mui/material';

import { NativePageBackground } from '../../../atoms/NativePageBackground/NativePageBackground';
import { useIsInBottomSlider } from '../../../molecules/BottomSlider/context';
import { variantConfigs } from '../../../molecules/MplPageHeader/config';
import { useStatusBarStyleSync } from '../../StatusBarStyleSyncProvider/context';

import { HeaderContainer, profileHeaderTitleSx } from './ProfileHeader.styles';

interface IProfileHeaderProps {
	title: string;
	open: boolean;
}

export const ProfileHeader = ({ title, open }: IProfileHeaderProps) => {
	const variant = 'primaryDark';
	const variantConfig = variantConfigs[variant];
	const isInBottomSlider = useIsInBottomSlider();
	const { push, pop } = useStatusBarStyleSync();

	useEffect(() => {
		if (open && isInBottomSlider && variantConfig?.statusBarColor) {
			push({
				title,
				style: variantConfig.statusBarColor,
			});

			return () => {
				pop();
			};
		}

		return;
	}, [open, isInBottomSlider, variantConfig, push, title, pop]);

	return (
		<>
			<HeaderContainer
				bgColor={variantConfig.bgColor}
				className="withSafeAreaTop"
				data-testid="profile-header-container"
			>
				<Typography
					sx={profileHeaderTitleSx}
					variant="h2-sb"
					data-testid="profile-header-title"
				>
					{title}
				</Typography>
			</HeaderContainer>
			{open && <NativePageBackground bgColor={variantConfig.bgColor} />}
		</>
	);
};
